export default __webpack_public_path__ + "3559cfdd9e991da8cb06afb63b5dc948.png";